import { useInfiniteQuery as useReactInfiniteQuery } from 'react-query';
export default function useInfiniteQuery(queryKey, queryFn, options) {
  const query = useReactInfiniteQuery(queryKey, queryFn, options);
  return query;
}